import style from "./List.module.css";
import ListItem from "./ListItem";

const List = (props) => {
  function onClickHandler(i) {
    props.onClick(i);
  }

// console.log(props.data);

  return (
    <div className={style.list}>
      {props.data.map((org, index1) =>
        org.items.map((item, index) => (
          <ListItem
            key={index}
            data={item}
            onClick={onClickHandler}
            modified={props.data.modified}
          />
        ))
      )}
    </div>
  );
};

export default List;
